import type { YMaps } from '@cian/frontend-ymaps-components/es/types/ymaps';

export const YANDEX_MAP_API_KEY_CONFIG_KEY = 'YANDEX_MAP_V3_API_KEY';

export type TMapPlatform = 'desktop' | 'mobile';

/** Поля по краям карты, в которых пины не рисуются (top / right / bottom / left). */
export const MAP_MARGIN: Record<TMapPlatform, YMaps.Margin> = {
  desktop: [56, 56, 56, 56],
  mobile: [24, 8, 24, 8],
};
